<div class="flex flex-col">
  <mat-table #tableMaterial [dataSource]="dataSourceMaterials" class="matching-table">
    <!-- Original material name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell i18n *matHeaderCellDef>Материал из модели</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ formatOriginMaterial(item) }}
      </mat-cell>
    </ng-container>

    <!-- Original material thickness Column -->
    <ng-container matColumnDef="thickness">
      <mat-header-cell i18n *matHeaderCellDef>Толщина</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ item.materialThickness }}
      </mat-cell>
    </ng-container>

    <!-- Linked material name Column -->
    <ng-container matColumnDef="link_name">
      <mat-header-cell i18n *matHeaderCellDef>Материал для производства</mat-header-cell>
      <mat-cell *matCellDef="let item" class="pr-2">
        <span *ngIf="item.linkedMaterialName">{{ item.linkedMaterialName }}</span>
        <span class="not-linked-material-name" *ngIf="!item.linkedMaterialName" i18n>Не назначен</span>
      </mat-cell>
    </ng-container>

    <!-- Link button Column -->
    <ng-container matColumnDef="btnlink">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let item">
        <button i18n-matTooltip mat-icon-button (click)="linkMaterial(item)" matTooltip="Выбрать материал">
          <mat-icon class="mat-24" aria-label="">edit</mat-icon>
        </button>
        <button
          i18n-matTooltip
          mat-icon-button
          (click)="removeLinkedMaterial(item)"
          matTooltip="Отменить сопоставление">
          <mat-icon aria-label="Remove material">cancel</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="materialDisplayedColumns"></mat-header-row>
    <mat-row *matRowDef="let item; columns: materialDisplayedColumns"></mat-row>
  </mat-table>

  <mat-table #tableButts [dataSource]="dataSourceButts" class="matching-table">
    <!-- Original butt name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell i18n *matHeaderCellDef>Облицовка из модели</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ formatOriginMaterial(item) }}
      </mat-cell>
    </ng-container>

    <!-- Original material thickness Column -->
    <ng-container matColumnDef="thickness">
      <mat-header-cell i18n *matHeaderCellDef>Толщина</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <p class="text-truncate">{{ item.materialThickness }}</p>
      </mat-cell>
    </ng-container>

    <!-- Linked butt name Column -->
    <ng-container matColumnDef="link_name">
      <mat-header-cell i18n *matHeaderCellDef>Облицовка для производства</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <span *ngIf="item.linkedMaterialName">{{ item.linkedMaterialName }}</span>
        <span class="not-linked-material-name" *ngIf="!item.linkedMaterialName" i18n>Не назначена</span>
      </mat-cell>
    </ng-container>

    <!-- Link button Column -->
    <ng-container matColumnDef="btnlink">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let item">
        <button i18n-matTooltip mat-icon-button (click)="linkButt(item)" matTooltip="Выбрать материал">
          <mat-icon class="mat-24" aria-label="">edit</mat-icon>
        </button>
        <button i18n-matTooltip mat-icon-button (click)="removeLinkedButt(item)" matTooltip="Отменить сопоставление">
          <mat-icon aria-label="Remove edge">cancel</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="buttDisplayedColumns"></mat-header-row>
    <mat-row *matRowDef="let item; columns: buttDisplayedColumns"></mat-row>
  </mat-table>

  <mat-table #tableSlots [dataSource]="dataSourceSlots" class="matching-table" *ngIf="dataSourceSlots.data.length > 0">
    <!-- Original slot name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell i18n *matHeaderCellDef>Паз из модели</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ formatOriginMaterial(item) }}
      </mat-cell>
    </ng-container>

    <!-- Linked slot name Column -->
    <ng-container matColumnDef="link_name">
      <mat-header-cell i18n *matHeaderCellDef>Паз для производства</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <span *ngIf="item.linkedMaterialName">{{ item.linkedMaterialName }}</span>
        <span class="not-linked-material-name" *ngIf="!item.linkedMaterialName" i18n>Не назначен</span>
      </mat-cell>
    </ng-container>

    <!-- Link button Column -->
    <ng-container matColumnDef="btnlink">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let item">
        <button i18n-matTooltip mat-icon-button (click)="linkSlot(item)" matTooltip="Выбрать паз">
          <mat-icon class="mat-24" aria-label="">edit</mat-icon>
        </button>
        <button i18n-matTooltip mat-icon-button (click)="removeLinkedSlot(item)" matTooltip="Отменить сопоставление">
          <mat-icon aria-label="Remove slot">cancel</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="slotDisplayedColumns"></mat-header-row>
    <mat-row *matRowDef="let item; columns: slotDisplayedColumns"></mat-row>
  </mat-table>

  <mat-table
    #tableFasteners
    [dataSource]="dataSourceFasteners"
    class="matching-table"
    *ngIf="dataSourceFasteners.data.length > 0">
    <!-- Original Fastener name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell i18n *matHeaderCellDef>Фурнитура из модели</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ formatOriginMaterial(item) }}
      </mat-cell>
    </ng-container>

    <!-- Linked Fastener name Column -->
    <ng-container matColumnDef="link_name">
      <mat-header-cell i18n *matHeaderCellDef>Фурнитура для производства</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <span *ngIf="item.linkedMaterialName">{{ item.linkedMaterialName }}</span>
        <span class="not-linked-material-name" *ngIf="!item.linkedMaterialName" i18n>Не назначена</span>
      </mat-cell>
    </ng-container>

    <!-- Link button Column -->
    <ng-container matColumnDef="btnlink">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let item">
        <button i18n-matTooltip mat-icon-button (click)="linkFastener(item)" matTooltip="Выбрать фурнитуру">
          <mat-icon class="mat-24" aria-label="">edit</mat-icon>
        </button>
        <button
          i18n-matTooltip
          mat-icon-button
          (click)="removeLinkedFastener(item)"
          matTooltip="Отменить сопоставление">
          <mat-icon aria-label="Remove fastener">cancel</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="fastenerDisplayedColumns"></mat-header-row>
    <mat-row *matRowDef="let item; columns: fastenerDisplayedColumns"></mat-row>
  </mat-table>

  <mat-table
    #tableAssembly
    [dataSource]="dataSourceAssembly"
    class="matching-table"
    *ngIf="dataSourceAssembly.data.length > 0">
    <ng-container matColumnDef="name">
      <mat-header-cell i18n *matHeaderCellDef>Покупные изделия из модели</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ formatOriginMaterial(item) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="link_name">
      <mat-header-cell i18n *matHeaderCellDef>Покупные изделия для производства</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <span *ngIf="item.linkedMaterialName">{{ item.linkedMaterialName }}</span>
        <span class="not-linked-material-name" *ngIf="!item.linkedMaterialName" i18n>Не назначено</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="btnlink">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let item">
        <button i18n-matTooltip mat-icon-button (click)="linkAssembly(item)" matTooltip="Выбрать покупное изделие">
          <mat-icon aria-label="">edit</mat-icon>
        </button>
        <button
          i18n-matTooltip
          mat-icon-button
          (click)="removeLinkedAssembly(item)"
          matTooltip="Отменить сопоставление">
          <mat-icon aria-label="Remove assembly">cancel</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="assemblyDisplayedColumns"></mat-header-row>
    <mat-row *matRowDef="let item; columns: assemblyDisplayedColumns"></mat-row>
  </mat-table>
</div>
